import _defineProperty from "@babel/runtime/helpers/defineProperty";


import { css } from 'styled-components';
import { Size } from './types';
var _modalSizeMixin;
export var modalSizeMixin = (_modalSizeMixin = {}, _defineProperty(_modalSizeMixin, Size.Xs, css(["max-width:300px;"])), _defineProperty(_modalSizeMixin, Size.Sm, css(["max-width:600px;"])), _defineProperty(_modalSizeMixin, Size.Md, css(["max-width:960px;"])), _defineProperty(_modalSizeMixin, Size.Lg, css(["max-width:1280px;"])), _defineProperty(_modalSizeMixin, Size.Xl, css(["max-width:1920px;"])), _modalSizeMixin);